/** @enum {string} */
const ImageType = Object.freeze({
    PNG: "png",
    WEBP: "webp",
    JPEG: "jpeg"
})

export default ImageType;